import { render, staticRenderFns } from "./PlaneButton.vue?vue&type=template&id=0df65094&lang=pug&"
import script from "./PlaneButton.vue?vue&type=script&lang=js&"
export * from "./PlaneButton.vue?vue&type=script&lang=js&"
import style0 from "./PlaneButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports